import React, { memo } from 'react';
import Button from '../../../components/Button';
import palette from '../../../components/styles/palette';

const AddDriverButton = ({ handleAddDriver, disabled }) => (
  <Button
    onClick={handleAddDriver}
    variant="contained"
    disableElevation
    disabled={disabled}
    border="1px solid #328442"
    bgColor={palette.green}
    data-testid="add-driver"
  >
    Add New Driver
  </Button>
);

export default memo(AddDriverButton);
